<div class="forgot-pane">
  <div class="forgot-title">
    <span class="block text-2xl font-bold text-[#27272A]">Esqueci minha senha</span>
    <span class="block text-sm text-zinc-500" style="margin-top: 4px;">
      Informe o e-mail cadastrado na plataforma e enviaremos uma nova senha de acesso.
    </span>
  </div>

  @if (showMessage && messageType === 'success') {
    <div class="forgot-msg forgot-msg--success">
      {{ message }}
    </div>
  }
  @if (showMessage && messageType === 'error') {
    <div class="forgot-msg forgot-msg--error">
      {{ message }}
    </div>
  }

  <form [formGroup]="forgotMyPasswordForm" autocomplete="off">
    <div class="form-field">
      <label for="email">E-mail</label>
      <app-input
        formControlName="email"
        type="text"
        [placeholder]="'Informe seu e-mail'"
        required="true"
      ></app-input>
    </div>

    @if (timeLeftToResendInMs && timeLeftToResendInMs > 0) {
      <div class="forgot-cooldown">
        <span>
          Você pode reenviar outro e-mail em 00:{{ timeLeftToResendInMs / 1000 | number:'2.0-0' }}
        </span>
      </div>
    }

    <div class="forgot-actions">
      <app-button
        (onClick)="sendMail()"
        [props]="{
          label: 'Enviar e-mail',
          style: { width: '100%', height: '40px'},
          loading: isLoadingSendMail,
          disabled: isLoadingSendMail || isDisabledByTimer
        }"
      />
      <app-button
        routerLink="/auth/login"
        [props]="{
          severity: 'secondary',
          label: 'Voltar ao login',
          style: { width: '100%', height: '40px'},
          disabled: isLoadingSendMail
        }"
      />
    </div>
  </form>
</div>
